export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const CLEAR_USER = "CLEAR_USER";
